/**
 * Regex to check Japanese Mobile Phone number format
 */
export const JapaneseMobileRegex: RegExp = /^0[7-9]{1}0[- ]?[0-9]{4}[- ]?[0-9]{4}$/